import { REHYDRATE_USER_SESSION, SET_UP_USER_PRODUCT, SET_UP_USER_HOTEL, UPDATE_USER_PRODUCT_PRICE_FAILURE, UPDATE_USER_PRODUCT_PRICE_REQUEST, UPDATE_USER_PRODUCT_PRICE_SUCCESS, UPDATE_USER_PRODUCT_SUCCESS, UPDATE_USER_PRODUCT_REMOVE_PROMO } from "../types";

const initialState = {
  hotel: {
    name: '',
    hotelType: '',
    city: '',
    reviews: '',
    rating: '',
    products: [],
  },
  product: {
    index: '',
    id: '',
    name: '',
    type: '',
    isKidAllow: '',
    maxGuests: '',
    calendar: '',
    image: '',
    meta: {
      keywords: '',
      description: '',
    },
    price: {
      isFetching: true,
      isErrored: null,
      discountName: '',
      newPrice: '',
      oldPrice: '',
      total: 0,
      oldTotal: 0,
      tax: 0,
      rate: 0,
    }
  }
};

export default function (state = initialState, action) {
  switch (action.type) {
    case REHYDRATE_USER_SESSION:
      return {
        ...action.payload,
      };
    case SET_UP_USER_PRODUCT:
    case UPDATE_USER_PRODUCT_SUCCESS:
      return {
        ...state,
        product: {
          ...state.product,
          ...action.payload.product,
        }
      };
    case SET_UP_USER_HOTEL:
      return {
        ...state,
        hotel: {
          ...state.hotel,
          ...action.payload.hotel,
        }
      };
    case UPDATE_USER_PRODUCT_PRICE_REQUEST:
      return {
        ...state,
        product: {
          ...state.product,
          price: {
            ...state.product.price,
            isFetching: true,
            isErrored: null,
          },
        }
      };
    case UPDATE_USER_PRODUCT_PRICE_SUCCESS:
      return {
        ...state,
        product: {
          ...state.product,
          price: {
            ...action.payload,
            isFetching: false,
            isErrored: false,
          },
        }
      };
    case UPDATE_USER_PRODUCT_PRICE_FAILURE:
      return {
        ...state,
        product: {
          ...state.product,
          price: {
            isFetching: false,
            isErrored: true,
            discountName: '',
            newPrice: 0,
            oldPrice: 0,
            total: 0,
            oldTotal: 0,
          },
        }
      };
    case UPDATE_USER_PRODUCT_REMOVE_PROMO:
      return {
        ...state,
        product: {
          ...state.product,
          price: {
            isFetching: false,
            ...action.payload,
          },
        }
      };
    default:
      return state;
  }
}
